import React from 'react';
import Footer from './Footer';
import Navbar from './Navbar';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SwiperCore } from 'swiper';
import 'swiper/swiper-bundle.min.css'
import '../../assets/frontend/css/core.css';
import '../../assets/frontend/css/bootstrap.css';
import '../../assets/frontend/css/font-awesome.min.css';
import '../../assets/frontend/css/swiper-slider.min.css';
import '../../assets/frontend/js/core.js';


// import 'font-awesome/css/font-awesome.min.css';
import { Redirect, Route, Switch } from 'react-router-dom';
import Routes from '../../routes/frontend/Routes';
const MasterLayoutFrontend = () => {
    return (
        <>
            <Navbar />
            <Switch>
                {Routes.map((route, idx) => {
                    return (
                        route.component && (
                            <Route
                                key={idx}
                                path={route.path}
                                exact={route.exact}
                                name={route.name}
                                render={({ props, location }) => {
                                    if (localStorage.getItem('auth_token')) {
                                        if (route.name === 'Register' || route.name === 'Login') {
                                            return <Redirect to={{ pathname: "/", state: { from: location } }} />
                                        } else {
                                            return <route.component {...props} />
                                        }
                                    } else {
                                        return <route.component {...props} />
                                    }
                                }
                                }
                            />
                        )
                    )
                })}
            </Switch>
            <Footer />
        </>
    )
}
export default MasterLayoutFrontend;


/* <Route If
condition={(() => {
    return true
})()}
key={idx}
path={route.path}
exact={route.exact}
name={route.name}
render={({props, location}) =>
localStorage.getItem('auth_token') ?
(<Redirect to={{pathname:"/", state:{from:location}}}/>) :
(<route.component {...props} />)
}
/> */